import { LS_JWT_KEY } from '../const/api'

export const getJwtToken = () => localStorage.getItem(LS_JWT_KEY)
